import { render, staticRenderFns } from "./box-input-qr.vue?vue&type=template&id=8c1a1c3e&scoped=true&"
import script from "./box-input-qr.vue?vue&type=script&lang=js&"
export * from "./box-input-qr.vue?vue&type=script&lang=js&"
import style0 from "./box-input-qr.vue?vue&type=style&index=0&id=8c1a1c3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c1a1c3e",
  null
  
)

export default component.exports